document.addEventListener("DOMContentLoaded", () => {
    const loadingPage = document.getElementById("loading-page");
    if (!loadingPage) return;

    const showLoading = () => {
        loadingPage.style.display = "flex";
        loadingPage.style.opacity = "1";
    };

    const removeLoading = () => {
        loadingPage.style.overflowY = "auto";
        loadingPage.style.display = "none";
        loadingPage.style.opacity = "0";
        setTimeout(() => {
            loadingPage.parentNode.removeChild(loadingPage);
        }, 200);
    };

    showLoading();

    window.addEventListener("load", removeLoading);
    window.addEventListener("beforeunload", showLoading);
});

function getElementTotalHeight(element) {
    const computedStyle = window.getComputedStyle(element);
    const marginTop = parseFloat(computedStyle.marginTop);
    const marginBottom = parseFloat(computedStyle.marginBottom);
    return element.offsetHeight + marginTop + marginBottom;
}

document.addEventListener("DOMContentLoaded", () => {
    var body = document.querySelector("body");
    var header = document.getElementById("header");

    function setBodyPadding() {
        var headerHeight = getElementTotalHeight(header);
        body.style.paddingTop = headerHeight + "px";
    }

    setBodyPadding();

    window.addEventListener("resize", setBodyPadding);
});

/*
document.addEventListener('DOMContentLoaded', () => {
    var banner = document.querySelector('.breadscrumbs-banner.banner-large');
    var header = document.getElementById('header');
    var breadscrumbs = document.querySelector('.breadscrumbs-wrap');
    if (banner && header && breadscrumbs) {
        function setBannerMinHeight() {
            var headerHeight = getElementTotalHeight(header);
            var breadscrumbsHeight = getElementTotalHeight(breadscrumbs);
            var windowHeight = window.innerHeight - headerHeight - breadscrumbsHeight;
            banner.style.minHeight = windowHeight + 'px';
        }
        setBannerMinHeight();
        window.addEventListener('resize', setBannerMinHeight);
    }
});
*/

if (document.querySelector(".slides-categorias")) {
    var swiper_categogias = new Swiper(".slides-categorias .swiper", {
        slidesPerView: 1,
        spaceBetween: 0,
        navigation: {
            nextEl: ".btn-category-next",
            prevEl: ".btn-category-prev",
        },
        breakpoints: {
            580: {
                slidesPerView: "auto",
                spaceBetween: 5,
            },
        },
    });
}

if (document.querySelector("#product-slides .swiper-thumbs")) {
    var swiper_product_thumbs = new Swiper(".swiper-thumbs", {
        rewind: true,
        loop: false,
        spaceBetween: 10,
        slidesPerView: 10,
        freeMode: true,
        watchSlidesProgress: true,
    });
}

if (document.querySelector("#product-slides .swiper-image")) {
    swiper_product_image = new Swiper(".swiper-image", {
        loop: true,
        slidesPerView: 1,
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        thumbs: {
            swiper: swiper_product_thumbs,
        },
    });
}

if (document.querySelector(".swiper-slides")) {
    swiper_slides = new Swiper(".swiper-slides", {
        slidesPerView: 1,
        rewind: true,
        loop: false,
        navigation: {
            nextEl: ".swiper-slides .swiper-button-next",
            prevEl: ".swiper-slides .swiper-button-prev",
        },
    });
}

if (document.querySelector(".carrossel-relateds")) {
    var swiper_carrossel_relateds = new Swiper(".carrossel-relateds .swiper", {
        slidesPerView: 1.5,
        spaceBetween: 7,
        centeredSlides: false,
        centeredSlidesBounds: true,
        loop: false,
        freeMode: true,
        rewind: true,
        speed: 500,
        breakpoints: {
            767: {
                slidesPerView: 2.5,
            },
            991: {
                slidesPerView: 3.5,
            },
        },
        navigation: {
            nextEl: ".carrossel-relateds .swiper-button-next",
            prevEl: ".carrossel-relateds .swiper-button-prev",
        },
    });
}

lightbox.option({
    albumLabel: "Imagem %1 de %2",
    wrapAround: true,
    maxWidth: 1320,
});

jQuery(function ($) {
    let header = $("#header");
    let isVisibleHeader = false;

    let $body = $("body");
    let $header = $("#header");

    $(window).on("scroll", function () {
        if ($(window).scrollTop() > 50 && !isVisibleHeader) {
            header.addClass("scrolled");
            $(".hide-on-scroll").stop(true, true).slideUp();
            $(".show-on-scroll").stop(true, true).slideDown();
            isVisibleHeader = true;

            $("#main").on("mouseenter", function () {
                $("#header.scrolled #header-nav").stop(true, true).slideUp();
            });
        } else if ($(window).scrollTop() < 50 && isVisibleHeader) {
            header.removeClass("scrolled");
            $(".hide-on-scroll").stop(true, true).slideDown();
            $(".show-on-scroll").stop(true, true).slideUp();
            isVisibleHeader = false;
        }
    });

    $("#header-wrap").on("mouseenter", function () {
        $("#header-nav").stop(true, true).slideDown();
    });

    $("#header-promo .close-promo").on("click", function (e) {
        e.preventDefault();
        document.cookie =
            "sobremesah_promo_closed=true; expires=Session; path=/";
        $("#header-promo").remove();

        function setBodyPaddingClose() {
            var headerHeight = getElementTotalHeight($header[0]);
            $body.css("padding-top", headerHeight + "px");
        }

        setBodyPaddingClose();
    });

    $("#btn-nav-header-float").on("click", function () {
        $("#header-nav").stop(true, true).slideToggle();
    });

    

    $(".product-image-thumbnails .img-thumb").on("click", function (e) {
        e.preventDefault();

        var $newSrcProduct = $(this).attr("data-src");
        var $imgProduct = $(".product-image .img-product");
        var $loadingImage = $(".product-image .loading-image");
        $loadingImage.css("z-index", 3);
        $imgProduct.fadeOut(300, function () {
            $imgProduct.attr("src", $newSrcProduct).fadeIn(300);
            $loadingImage.css("z-index", 1);
        });
    });

    $(".menu-item .btn-sub").on("click", function (e) {
        $(this).closest(".menu-item").find(".sub-menu").slideToggle();
    });

    $('.comment-reply-link').on('click', function(e){        
        var postid = $(this).data('postid');
        var commentid = $(this).data('commentid');
        var replyto = $(this).data('replyto') + ' <button id="cancel-replyto" class="btn btn-outline-dark rounded-pill px-4">Cancelar</button>';        
        $('#comment_parent').val(commentid);
        $('#reply-title').html(replyto);

        $('#cancel-replyto').on('click', function(e){
            $('#comment_parent').val('0');
            $('#reply-title').html('Deixe um comentário');
        });

    });
});
